import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { Upload } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useCurrentFolderContext, useUploadFile } from 'src/models/documentsLibrary/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUpload } from '@fortawesome/pro-light-svg-icons';
import { RcFile } from 'antd/lib/upload';

const { Dragger } = Upload;

interface IProps {}

export const DocumentsEmptyFolder: FC<IProps> = () => {
  const { t } = useTranslation();
  const [uploadFile] = useUploadFile();
  const currentFolder = useCurrentFolderContext();

  const onUpload = useCallback(
    (file: RcFile) => {
      uploadFile(file, currentFolder.id);
      return Upload.LIST_IGNORE;
    },
    [uploadFile, currentFolder.id]
  );

  return (
    <Dragger name="file" className={styles.docsActionUpload} showUploadList={false} beforeUpload={onUpload}>
      <div className={styles.content}>
        <div className={styles.title}>{t('DocumentLibrary.folderEmpty')}</div>
        <FontAwesomeIcon icon={faCloudUpload} className={styles.icon} />
        <div className={styles.desc}>{t('DocumentLibrary.dndUploadFiles')}</div>
      </div>
    </Dragger>
  );
};

export default DocumentsEmptyFolder;
